export default {"src":"https://fishbrain.com/_next/static/media/northernPike.1b25dce5.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};